var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderConstructionImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 99,
    viewBox: "0 0 140 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M57.5028 91.5482H97.2089C97.345 91.5482 97.4358 91.3208 97.4358 91.048V87.6375C97.4358 87.4556 97.3904 87.2737 97.2996 87.1827L94.9399 84.8181C83.0054 72.8587 68.8927 73.7227 57.3666 87.1827C57.2759 87.2737 57.2305 87.4101 57.2305 87.592V91.0025C57.2758 91.3208 57.3666 91.5482 57.5028 91.5482Z",
    fill: "#4F4D40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M83.6867 77.042H73.4766V85.6364",
    fill: "#4F4D40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M71.6172 85.4092L76.1097 93.0487L82.145 89.5018",
    fill: "#4F4D40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M78.9219 84.7275L84.5942 91.5031L89.9488 86.9557",
    fill: "#4F4D40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M84.4156 82.3623H76.8828V88.7286",
    fill: "#4F4D40"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M75.3828 77.4961L79.8753 85.1356L85.9106 81.5887",
    fill: "#4F4D40"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M85.5012 81.4521L78.7852 89.1371L85.2743 94.8213",
    fill: "#4F4D40"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M97.028 86.2733L92.3994 77.1787L84.7305 81.0894",
    fill: "#4F4D40"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M85.3672 92.1845L94.7605 88.2283L91.4025 80.2705",
    fill: "#4F4D40"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M77.4253 87.7745L81.3279 78.3615L73.3867 75.042",
    fill: "#4F4D40"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M73.2034 75.8604L64.4453 77.0881L65.3982 84.0001",
    fill: "#4F4D40"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M72.1591 80.4082L63.7188 83.0457L65.8515 89.7302",
    fill: "#4F4D40"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M72.2074 86.411L75.1116 79.4536L69.2578 76.998",
    fill: "#4F4D40"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M80.1486 79.9531L71.3906 81.1354L72.3436 88.0928",
    fill: "#4F4D40"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M72.6145 87.728L68.1674 78.5879L60.4531 82.4076",
    fill: "#4F4D40"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M68.2578 92.0491L78.4226 91.2761L77.7419 82.6816",
    fill: "#4F4D40"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M62.8125 83.5V93.686H71.4344",
    fill: "#4F4D40"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.277 96.1868H42.5273V89.3203H49.3795C53.1913 89.3203 56.277 92.4125 56.277 96.1868Z",
    fill: "#4F4D40"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2359 66.992L52.8728 66.3554L37.4895 45.9834L27.4609 54.1686L43.4795 73.813L53.2359 66.992Z",
    fill: "#FBBA1C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5066 68.6297V67.1291L41.3906 65.583L42.2982 93.2762C46.3822 93.1398 49.831 90.1385 50.5117 86.0914L53.5066 68.6297Z",
    fill: "#FBBA1C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7409 85.2725H41.9375V86.7276H50.4687L50.7409 85.2725Z",
    fill: "#D1D0A7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.07 91.8645H4.32031V85.7256C4.32031 85.3164 4.63795 84.998 5.04636 84.998H11.1724C14.9842 84.998 18.07 88.0902 18.07 91.8645Z",
    fill: "#4F4D40"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86719 87.1354L26.4639 43.3447L41.5749 51.5299L13.5765 85.0891C10.9445 88.2268 6.45208 89.0908 2.86719 87.1354Z",
    fill: "#FFD305"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5789 63.0972L17.3477 60.2676L11.6141 70.9119L16.8454 73.7415L22.5789 63.0972Z",
    fill: "#D1D0A7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8021 83.6343L6.99708 79.4053L6.31641 80.6785L13.8492 84.7711L14.8021 83.6343Z",
    fill: "#D1D0A7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M61.6294 30.2529C57.8176 30.935 55.0495 34.0727 55.4579 37.2103L58.2714 59.0374C62.0832 58.3553 64.8512 55.2177 64.4428 52.0801L61.6294 30.2529Z",
    fill: "#A09E80"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8993 46.3953C59.9967 47.4866 56.5026 46.4862 55.7765 42.8029L52.5547 26.2961C56.4572 25.2048 60.1783 27.342 60.9043 31.0254L63.8993 46.3953Z",
    fill: "#A09E80"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6355 25.2474L48.6976 19.3814C45.4304 17.4715 41.2102 18.5174 39.3043 21.7914L26.3714 43.755C25.3277 45.5285 25.9177 47.8021 27.6874 48.8025L41.0741 56.7149C43.5699 58.2155 46.7917 57.3515 48.2892 54.8505L60.8136 33.6145C62.4926 30.7042 61.5397 26.9754 58.6355 25.2474Z",
    fill: "#A09E80"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3652 20.5198L48.787 16.018C46.2912 14.5628 43.0693 15.3814 41.6172 17.8824L27.8675 41.2556C26.8238 43.0291 27.4138 45.3027 29.1835 46.3031L41.7533 53.7153C44.9298 55.5797 49.0138 54.5338 50.8744 51.3506L60.2224 35.4805C63.2627 30.2966 61.5383 23.5665 56.3652 20.5198Z",
    fill: "#D1D0A7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5004 20.6532L48.5625 14.7871L54.0533 5.46515C55.4146 3.14601 58.4096 2.37297 60.7239 3.73716L66.487 7.14765C68.8013 8.51185 69.5727 11.5131 68.2114 13.8322L65.171 18.9707C63.8096 21.2443 60.8147 22.0174 58.5004 20.6532Z",
    fill: "#D1D0A7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2621 18.0174C62.1294 16.7442 59.5882 17.108 58.5898 18.8359L66.3042 23.3833C67.2571 21.6553 66.3495 19.2452 64.2621 18.0174Z",
    fill: "#A09E80"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3775 8.83081C49.8346 11.4683 49.6531 14.2876 50.9691 15.0606L56.596 5.4658C55.3254 4.69275 52.9658 6.19336 51.3775 8.83081Z",
    fill: "#A09E80"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9643 9.37696L69.9811 19.4265L68.0299 14.379L69.1189 12.5601C71.0702 9.24054 69.3004 4.51133 65.1256 2.05578C60.9508 -0.399774 55.9592 0.282321 54.0079 3.60186L52.0567 6.92141C51.5575 7.69445 52.0113 8.78581 52.9643 9.37696Z",
    fill: "#FFD305"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66.001 18.9458C66.4214 18.232 65.9923 17.1981 65.0426 16.6365C64.093 16.0748 62.9823 16.198 62.562 16.9118C62.1416 17.6255 62.5706 18.6594 63.5203 19.2211C64.47 19.7828 65.5806 19.6595 66.001 18.9458Z",
    fill: "#D1D0A7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M100.928 67.72L90.8091 84.9543L75.3804 75.8597C72.1132 73.9498 71.0241 69.7208 72.93 66.4467L76.0611 61.0809C77.967 57.8068 82.1872 56.7155 85.4544 58.6253L100.928 67.72Z",
    fill: "#A09E80"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3256 66.0833L2.36718 19.5188C1.59575 19.064 0.597406 19.2914 0.189001 20.019C-0.219405 20.7466 0.0528767 21.747 0.824309 22.2017L79.7827 68.7662C80.5541 69.221 81.5524 68.9936 81.9608 68.266C82.3692 67.5385 82.097 66.538 81.3256 66.0833Z",
    fill: "#4F4D40"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2771 51.7598L69.3461 56.0797C68.1663 59.6721 64.2637 61.6729 60.6789 60.4451C57.094 59.3083 55.0973 55.3976 56.2771 51.7598Z",
    fill: "#A09E80"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M27.1891 17.3809C23.6496 18.9724 21.5622 22.2465 22.4698 24.6566L29.0043 41.6635C32.5438 40.072 34.6312 36.7979 33.7236 34.3878L27.1891 17.3809Z",
    fill: "#A09E80"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5156 24.3839C22.924 19.973 25.6921 16.608 30.5476 17.0627L52.2839 18.9726C51.8755 23.3835 47.6099 26.6121 42.709 26.1573L22.5156 24.3839Z",
    fill: "#A09E80"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1909 33.1592L39.3069 39.7073C37.4918 43.0723 33.317 44.3001 30.0044 42.4812C26.6464 40.7077 25.4212 36.5242 27.1909 33.1592Z",
    fill: "#A09E80"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M83.324 93.732H139.639C139.82 93.732 140.002 93.4137 140.002 93.0499V88.2298C140.002 87.9569 139.911 87.7296 139.82 87.5931L136.508 84.2736C119.581 67.3121 99.5695 68.5399 83.2333 87.5931C83.1425 87.7296 83.0518 87.9569 83.0518 88.1843V93.0499C83.0064 93.4592 83.1425 93.732 83.324 93.732Z",
    fill: "#4F4D40"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M120.446 73.1777H106.016V85.41",
    fill: "#4F4D40"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M103.383 85.0459L109.736 95.914L118.267 90.8665",
    fill: "#4F4D40"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M113.684 84.0918L121.761 93.6866L129.339 87.3204",
    fill: "#4F4D40"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M121.488 80.7275H110.824V89.7767",
    fill: "#4F4D40"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M108.691 73.8594L115.044 84.682L123.621 79.6799",
    fill: "#4F4D40"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M123.029 79.4531L113.5 90.3212L122.666 98.4154",
    fill: "#4F4D40"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M139.367 86.3191L132.832 73.4502L121.941 78.9525",
    fill: "#4F4D40"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M122.852 94.685L136.147 89.0918L131.428 77.8145",
    fill: "#4F4D40"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M111.597 88.4122L117.133 75.0886L105.879 70.3594",
    fill: "#4F4D40"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M101.066 76.0889L88.6328 77.7714L89.9942 87.6391",
    fill: "#4F4D40"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M104.11 77.999L92.1758 81.7733L95.1708 91.2317",
    fill: "#4F4D40"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M104.201 86.5019L108.33 76.6343L99.9805 73.1328",
    fill: "#4F4D40"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M115.455 77.3184L103.066 79.0463L104.382 88.8685",
    fill: "#4F4D40"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M104.789 88.4126L98.4362 75.4072L87.5 80.8185",
    fill: "#4F4D40"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M96.7109 96.369L111.096 95.2776L110.188 83.0908",
    fill: "#4F4D40"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M90.8594 82.4092L90.9047 96.8242H103.112",
    fill: "#4F4D40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstructionImg);
export default __webpack_public_path__ + "static/media/under-construction-img.cca5c1728f833ed0612a8fd87c41c7a7.svg";
export { ForwardRef as ReactComponent };